// extracted by mini-css-extract-plugin
export default {"card":"Card_card__p9wzB","fade":"Card_fade__QltHj","full-width":"Card_full-width__vl3CL","adminTableCustom":"Card_adminTableCustom__vKnnz"};